export enum AppInitRoutePaths {
    landing = '/*',
    empty = 'empty'
}
